import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import styles from './HorizontalScroll.module.css';

const HorizontalScroll = (props) => {
  const { children, className } = props;

  return (
    <div
      className={cn(className, {
        [styles.scroller]: true,
        [styles.scrollable]: true,
      })}
    >
      {children}
    </div>
  );
};

HorizontalScroll.propTypes = {
  children: Type.node.isRequired,
  className: Type.string,
};

HorizontalScroll.defaultProps = {
  className: undefined,
};

export default HorizontalScroll;
